import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import TypeWriter from '../components/TypeWriter';
import './Home.css';

const Home = ({ user }) => {
  const navigate = useNavigate();
  const [signLoading, setSignLoading] = useState(false);
  const [morseLoading, setMorseLoading] = useState(false);

  const handleSignLanguage = () => {
    setSignLoading(true);
    setTimeout(() => {
      setSignLoading(false);
      navigate('/sign-language');
    }, 1000);
  };

  const handleMorseCode = () => {
    setMorseLoading(true);
    setTimeout(() => {
      setMorseLoading(false);
      navigate('/morse-code');
    }, 1000);
  };

  return (
    <div className="home-page">
      <div className="container">
        {/* Welcome Section */}
        <div className="welcome-section card" data-aos="fade-up" data-aos-duration="900">
          <h1 className="welcome-title">
            <TypeWriter 
              text={`Welcome, ${user?.name || 'User'}! 👋`} 
              speed={80} 
              cursorColor="white"
              className="text-black"
            />
          </h1>
          <p className="welcome-subtitle">
            SignCrypt is an inclusive communication platform integrating gesture recognition, 
            Morse code input, and encrypted messaging for the speech and hearing-impaired community.
          </p>
        </div>

        {/* Project Introduction */}
        <div className="intro-section card" data-aos="fade-up" data-aos-delay="150" data-aos-duration="900">
          <h2 className="home-section-heading">About SignCrypt</h2>
          <p>
            Our platform combines cutting-edge technology with accessibility to create 
            a seamless communication experience. Whether you prefer sign language gestures 
            or Morse code patterns, SignCrypt adapts to your communication style while 
            ensuring your messages remain secure and private.
          </p>
        </div>

        {/* Main Action Buttons */}
        <div className="action-buttons">
          <div className="action-card card" data-aos="zoom-in" data-aos-delay="200" data-aos-duration="800">
            <div className="action-icon">🤟</div>
            <h3 className="home-section-heading">Sign Language</h3>
            <p>Use your webcam to communicate through ASL gestures</p>
            <button 
              className="btn btn-primary action-btn"
              onClick={handleSignLanguage}
              disabled={signLoading}
            >
              {signLoading ? 'Starting...' : 'Start Sign Language'}
            </button>
          </div>

          <div className="action-card card" data-aos="zoom-in" data-aos-delay="350" data-aos-duration="800">
            <div className="action-icon">📡</div>
            <h3 className="home-section-heading">Morse Code</h3>
            <p>Use hand gestures for dots (OK) and dashes (Swag)</p>
            <button 
              className="btn btn-primary action-btn"
              onClick={handleMorseCode}
              disabled={morseLoading}
            >
              {morseLoading ? 'Starting...' : 'Start Morse Code'}
            </button>
          </div>
        </div>

        {/* Features Grid */}
        <div className="features-grid">
          <div className="feature-item" data-aos="fade-right" data-aos-delay="100" data-aos-duration="700">
            <div className="feature-icon">🔒</div>
            <h4>Secure Encryption</h4>
            <p>Your messages are encrypted using advanced algorithms</p>
          </div>
          <div className="feature-item" data-aos="fade-up" data-aos-delay="200" data-aos-duration="700">
            <div className="feature-icon">🚨</div>
            <h4>Emergency SOS</h4>
            <p>Quick access to emergency contacts and alerts</p>
          </div>
          <div className="feature-item" data-aos="fade-up" data-aos-delay="300" data-aos-duration="700">
            <div className="feature-icon">💬</div>
            <h4>AI Assistant</h4>
            <p>Get help anytime with our intelligent chatbot</p>
          </div>
          <div className="feature-item" data-aos="fade-left" data-aos-delay="400" data-aos-duration="700">
            <div className="feature-icon">📱</div>
            <h4>Mobile Friendly</h4>
            <p>Optimized for all devices and screen sizes</p>
          </div>
        </div>

        {/* Quick Tips */}
        <div className="tips-section card" data-aos="fade-up" data-aos-delay="400" data-aos-duration="900">
          <h3 className="home-section-heading">Quick Tips</h3>
          <ul className="tips-list">
            <li data-aos="fade-right" data-aos-delay="500">Ensure good lighting for better gesture recognition</li>
            <li data-aos="fade-right" data-aos-delay="600">Keep your hands clearly visible in the camera frame</li>
            <li data-aos="fade-right" data-aos-delay="700">Add emergency contacts for SOS functionality</li>
            <li data-aos="fade-right" data-aos-delay="800">Use the chatbot for help with any features</li>
          </ul>
        </div>
      </div>
    </div>
  );
};

export default Home; 